/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  UserProfile
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Record that the caller finished or skipped "Connect your tools".
 *
 * Idempotent, like the welcome tour's: Skip all, the last row being settled,
 * and closing the dialog all land here, and a slow network can deliver two.
 * Only the first is kept. Anyone may call it; it connects nothing and grants
 * nothing, it only stops the step being offered again.
 *
 * Returns the profile so the client can drop the flag from its cache in the
 * same round trip.
 * @summary Mark Connect Tools Done
 */
export const markConnectToolsDone = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<UserProfile>(
      {url: `/user/connect-tools/done`, method: 'POST', signal
    },
      options);
    }




export const getMarkConnectToolsDoneMutationKey = () => ['markConnectToolsDone'] as const;

export const getMarkConnectToolsDoneMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markConnectToolsDone>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof markConnectToolsDone>>, TError,void, TContext> => {

const mutationKey = getMarkConnectToolsDoneMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markConnectToolsDone>>, void> = () => {


          return  markConnectToolsDone(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkConnectToolsDoneMutationResult = NonNullable<Awaited<ReturnType<typeof markConnectToolsDone>>>

    export type MarkConnectToolsDoneMutationError = unknown


    /**
 * @summary Mark Connect Tools Done
 */
export const useMarkConnectToolsDone = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markConnectToolsDone>>, TError,void, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markConnectToolsDone>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMarkConnectToolsDoneMutationOptions(options));
    }
